import React from 'react'
import prettysize from '../../../utils'
import { Icon } from 'antd'
import moment from 'moment'
import './styles.scss'

export default ({file}) => {
  const {bucket, cost, date, direction, files, files_count, is_directory, size} = file
  return (
      <div className='transfer-item columnWrap'>
        <div>
          {direction === 'upload' ? <Icon type="up"/> : <Icon type="down"/>}
          <span>{ bucket}</span>
        </div>
        <span className='size'>{prettysize(size )}</span>
        <span>{cost ? cost.toFixed(5) : 0}</span>
        <span>{moment(date).format('MMM-DD-YY')}</span>
      </div>
  )
}
